import { Permissions } from "@/modules/roles/domain/contracts/permissions";
import type { PermissionId } from "@/modules/roles/domain/contracts/permissions";
import type { LucideIcon } from "lucide-react";
import {
  CalendarClock,
  ClipboardCheck,
  FilePlus2,
  Palmtree,
  Users,
} from "lucide-react";

export type DashboardQuickAction = {
  title: string;
  url: string;
  icon: LucideIcon;
  variant?: "default" | "primary";
  permissionsAny: PermissionId[];
};

/** ປຸ່ມສ້າງ/ເປີດໜ້າທີ່ໃຊ້ບ่อย — ບໍ່ clone sidebar ທັງໝົດ */
export const dashboardQuickActions: DashboardQuickAction[] = [
  {
    title: "ສ້າງເອກະສານ",
    url: "/app/documents/new",
    icon: FilePlus2,
    variant: "primary",
    permissionsAny: [Permissions.quotation_invoice.create],
  },
  {
    title: "ປະຕິທິນວຽກ",
    url: "/app/management/calendar",
    icon: CalendarClock,
    permissionsAny: [
      Permissions.mgmt_calendar.read,
      Permissions.mgmt_calendar.team,
    ],
  },
  {
    title: "ບັນທຶກປະຊຸມ",
    url: "/app/management/meetings/new",
    icon: Users,
    permissionsAny: [Permissions.mgmt_meeting.create],
  },
  {
    title: "Checklist",
    url: "/app/checklists",
    icon: ClipboardCheck,
    permissionsAny: [Permissions.checklists.read],
  },
  {
    title: "ຂໍລາ",
    url: "/app/hr/leave/requests/new",
    icon: Palmtree,
    permissionsAny: [Permissions.hr_leave.request_create],
  },
];
